import myLegendInfo from "./myLegendInfo"

const myLayerInfo = {
    "baseMap" : {
        "esriImagery": {
            type: "wmts",
            shortName: "esriImagery",
            longName: "Esri Imagery",
            url: "https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.jpg",
            attLink: "https://services.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer",
            attText: "Esri",
        },
        "esriStreet": {
            type: "wmts",
            shortName: "esriStreet",
            longName: "Esri Street",
            url: "https://services.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}.jpg",
            attLink: "https://services.arcgisonline.com/arcgis/rest/services/World_Street_Map/MapServer",
            attText: "Esri",
        },
        "esriTopo": {
            type: "wmts",
            shortName: "esriTopo",
            longName: "Esri Topographic",
            url: "https://services.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}.jpg",
            attLink: "https://services.arcgisonline.com/arcgis/rest/services/World_Topo_Map/MapServer",
            attText: "Esri",
        },
        "osmStandard": {
            type: "wmts",
            shortName: "osmStandard",
            longName: "OSM Standard",
            url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
            attLink: "http://osm.org/copyright",
            attText: "OpenStreetMap",
        },
    },
    "flood": {
        "comp5": {
            type: "wmts",
            shortName: "comp5",
            longName: "VIIRS 5-day Composite",
            url: "https://floods.ssec.wisc.edu/tiles/RIVER-FLDglobal-composite/{z}/{x}/{y}.png",
            attLink: "https://www.ssec.wisc.edu/flood-map-demo/flood-products/",
            attText: "NOAA JPSS GOES-R CIMSS GMU",
            legend: myLegendInfo.flood,
            position: [10, 0],
            zoom: 3,
        },
        "comp1": {
            type: "wmts",
            shortName: "comp1",
            longName: "VIIRS 1-day Composite",
            url: "https://floods.ssec.wisc.edu/tiles/RIVER-FLDglobal-composite1/{z}/{x}/{y}.png",
            attLink: "https://www.ssec.wisc.edu/flood-map-demo/flood-products/",
            attText: "NOAA JPSS GOES-R CIMSS GMU",
            legend: myLegendInfo.flood,
            position: [10, 0],
            zoom: 3,
        },
        "jointABI": {
            type: "wmts",
            shortName: "jointABI",
            longName: "Joint VIIRS/ABI",
            url: "https://floods.ssec.wisc.edu/tiles/RIVER-FLD-joint-ABI/{z}/{x}/{y}.png",
            attLink: "https://www.ssec.wisc.edu/flood-map-demo/flood-products/",
            attText: "NOAA JPSS GOES-R CIMSS GMU",
            legend: myLegendInfo.flood,
            position: [0, -75],
            zoom: 3,
        },
        "jointAHI": {
            type: "wmts",
            shortName: "jointAHI",
            longName: "Joint VIIRS/AHI",
            url: "https://floods.ssec.wisc.edu/tiles/RIVER-FLD-joint-AHI/{z}/{x}/{y}.png",
            attLink: "https://www.ssec.wisc.edu/flood-map-demo/flood-products/",
            attText: "NOAA JPSS GOES-R CIMSS GMU",
            legend: myLegendInfo.flood,
            position: [1, 134],
            zoom: 3,
        },
    },
    "extra": {
        "pop2020": {
            type: "wms",
            shortName: "pop2020",
            longName: "Population Density (2020)",
            url: "https://sedac.ciesin.columbia.edu/geoserver/wms?",
            layers: "gpw-v4:gpw-v4-population-density_2020",
            attLink: "https://doi.org/10.7927/H49C6VHW",
            attText: "CIESIN SEDAC",
            legend: myLegendInfo.pop,
            position: [10, 0],
            zoom: 3,
        },
        "pop2000": {
            type: "wms",
            shortName: "pop2000",
            longName: "Population Density (2000)",
            url: "https://sedac.ciesin.columbia.edu/geoserver/wms?",
            layers: "gpw-v4:gpw-v4-population-density_2000",
            attLink: "https://doi.org/10.7927/H49C6VHW",
            attText: "CIESIN SEDAC",
            legend: myLegendInfo.pop,
            position: [10, 0],
            zoom: 3,
        },
        "floodHazard": {
            type: "wms",
            shortName: "floodHazard",
            longName: "Flood Hazard Freq. & Dist",
            url: "https://sedac.ciesin.columbia.edu/geoserver/wms?",
            layers: "ndh:ndh-flood-hazard-frequency-distribution",
            attLink: "https://doi.org/10.7927/H4668B3D",
            attText: "CHRR CIESIN SEDAC World Bank",
            legend: myLegendInfo.floodHazard,
            position: [10, 0],
            zoom: 3,
        },
        "totEcon": {
            type: "wms",
            shortName: "totEcon",
            longName: "Total Economic Risk",
            url: "https://sedac.ciesin.columbia.edu/geoserver/wms?",
            layers: "ndh:ndh-flood-total-economic-loss-risk-deciles",
            attLink: "https://doi.org/10.7927/H4T151KP",
            attText: "CHRR CIESIN SEDAC World Bank",
            legend: myLegendInfo.totEcon,
            position: [10, 0],
            zoom: 3,
        },
        "propEcon": {
            type: "wms",
            shortName: "propEcon",
            longName: "Proportional Economic Risk",
            url: "https://sedac.ciesin.columbia.edu/geoserver/wms?",
            layers: "ndh:ndh-flood-proportional-economic-loss-risk-deciles",
            attLink: "https://doi.org/10.7927/H4XS5S9Q",
            attText: "CHRR CIESIN SEDAC World Bank",
            legend: myLegendInfo.propEcon,
            position: [10, 0],
            zoom: 3,
        },

    },
};

export default myLayerInfo;